// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressController from "./address_controller"
import AutogrowController from "./autogrow_controller"
import BeckonController from "./beckon_controller"
import CompositionController from "./composition_controller"
import CountdownController from "./countdown_controller"
import DraftController from "./draft_controller"
import DisappearController from "./disappear_controller"
import FreshController from "./fresh_controller"
import PullController from "./pull_controller"
import HapticController from "./haptic_controller"
import BesideController from "./beside_controller"
import LifetimeController from "./lifetime_controller"
import CleoController from "./cleo_controller"
import ShortcutController from "./shortcut_controller"
import ShareController from "./share_controller"
import DialogController from "./dialog_controller"
import OpenController from "./open_controller"
import WordsController from "./words_controller"
import ChoiceController from "./choice_controller"
import FilingController from "./filing_controller"
import HandleController from "./handle_controller"
import LikenessController from "./likeness_controller"
import MenuController from "./menu_controller"
import PenNameController from "./pen_name_controller"
import PersonaController from "./persona_controller"
import AsideController from "./aside_controller"
import AsidesController from "./asides_controller"
import FormatController from "./format_controller"
import MentionController from "./mention_controller"
import TranslationsController from "./translations_controller"
import RenditionController from "./rendition_controller"
import OnwardController from "./onward_controller"

application.register("autogrow", AutogrowController)
application.register("address", AddressController)
application.register("beckon", BeckonController)
application.register("format", FormatController)
application.register("mention", MentionController)
application.register("composition", CompositionController)
application.register("countdown", CountdownController)
application.register("draft", DraftController)
application.register("disappear", DisappearController)
application.register("fresh", FreshController)
application.register("pull", PullController)
application.register("haptic", HapticController)
application.register("beside", BesideController)
application.register("lifetime", LifetimeController)
application.register("cleo", CleoController)
application.register("shortcut", ShortcutController)
application.register("share", ShareController)
application.register("dialog", DialogController)
application.register("open", OpenController)
application.register("words", WordsController)
application.register("choice", ChoiceController)
application.register("filing", FilingController)
application.register("handle", HandleController)
application.register("likeness", LikenessController)
application.register("menu", MenuController)
application.register("pen-name", PenNameController)
application.register("persona", PersonaController)
application.register("aside", AsideController)
application.register("asides", AsidesController)
application.register("translations", TranslationsController)
application.register("rendition", RenditionController)
application.register("onward", OnwardController)
